import { IAddFormPublishTermsResponse } from '../../../../repositories/billing-tariffs/v2/add-form/publish-terms';
import { IPaidPublicationState } from '../../../../reducers/v2';

export const mapPaidPublication = (response: IAddFormPublishTermsResponse): IPaidPublicationState => {
  return {
    isPaid: Boolean(response.publication?.period?.isPaid),
    days: Number(response.publication?.period?.days),
    highDemandCoefficient: Number(response.highDemandCoefficient),
    isEdit: response.publication?.period?.isPaid ? 'edit' : 'new',
    autoProlong: response.autoProlong,
    moderation: {
      isAllowed: true,
      unavailableReasonType: null,
    },
    price: Number(response.publication?.period?.price),
    token: String(response.publication?.period?.token),
  };
};
